// @flow
import * as React from 'react';
import {useState} from 'react';
import Box from 'sail/Box';
import {ButtonLink} from 'sail/Button';
import {defineMessages, FormattedMessage} from 'react-intl';

import {usePrefs} from 'docs/data';

import {CheckoutDemo} from './demos/CheckoutDemo';
import {PaymentsDemo} from './demos/PaymentsDemo';
import {CardDemo} from './demos/CardDemo/CardDemo';

import './IntegrationBuilderDemo.scss';

const messages = defineMessages({
  preview: {
    id: 'docsApp.ib.demo.preview',
    description: 'Label for preview tab',
    defaultMessage: 'Preview',
  },
});

type DemoType = 'checkout' | 'payments' | 'card';
type DemoComponent = typeof CheckoutDemo | typeof PaymentsDemo;

const getDemo = (type: DemoType): ?React.Element<DemoComponent> => {
  switch (type) {
    case 'checkout':
      return <CheckoutDemo />;
    case 'payments':
      return <PaymentsDemo />;
    case 'card':
      return <CardDemo />;
    default:
      return null;
  }
};

type IntegrationBuilderDemoProps = {|
  type: DemoType,
|};

export const IntegrationBuilderDemo = ({type}: IntegrationBuilderDemoProps) => {
  const [expanded, setExpanded] = useState(type !== 'payments');
  const {getPref} = usePrefs();

  if (getPref('platform') !== 'web') {
    // We cannot render true demos of mobile experiences in the browser
    return null;
  }

  const demo = getDemo(type);

  if (!demo) {
    return null;
  }
  return (
    <Box
      className="IntegrationBuilderDemo"
      divider={{color: 'dark', width: 1, side: 'bottom'}}
    >
      <Box
        className="IntegrationBuilderDemo--container"
        padding={{top: 12, right: 24, left: 24, bottom: 0}}
        flex={{justifyContent: 'flex-start', alignItems: 'center'}}
      >
        <ButtonLink
          className="IntegrationBuilderDemo--expand-button"
          display="inline-flex"
          icon={expanded ? 'chevronUp' : 'chevronDown'}
          iconPosition="left"
          size="small"
          label={<FormattedMessage {...messages.preview} />}
          onClick={() => {
            setExpanded(!expanded);
          }}
        />
      </Box>
      {expanded && (
        <Box
          className="IntegrationBuilderDemo--view"
          flex={{
            direction: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {demo}
        </Box>
      )}
    </Box>
  );
};
